import { portalDs } from 'src/components/portal-design-system';
import { EtlRunsSectionV2 } from '../components/etl-runs-section-v2';
import { EtlHealthDashboardV2 } from '../components/etl-health-dashboard-v2';
import { PlatformHealthSection } from '../components/platform-health-section';
import { cn } from 'src/lib/utils';

const EtlDashboardTab = () => (
  <div className={cn(portalDs.page, 'h-full overflow-y-auto px-6 py-8 sm:px-10')}>
    <EtlRunsSectionV2 />
    <EtlHealthDashboardV2 />
    <div className="mt-8">
      <PlatformHealthSection />
    </div>
  </div>
);

export default EtlDashboardTab;
